<template>
  <BookForm
    :params="params"
    :result="result"
    @back="onBack"
    @book="onBook"
    />
</template>

<script>
import model from './services/model'
import BookForm from './components/book_form'

export default {
  components: { BookForm },
  data () {
    const routeParams = this.$route.params
    const result = model.results[routeParams.Result]

    return {
      params: model.params,
      result
    }
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Private/Bus/Search' })
    },
    onBook (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  }
}
</script>
